import { CopyOutlined, LoginOutlined, SettingOutlined } from '@ant-design/icons'
import { googleLogout } from '@react-oauth/google'
import { useWeb3Modal, useWeb3ModalState } from '@web3modal/wagmi/react'
import { Button, Dropdown, message, Modal, Tooltip } from 'antd'
import copy from 'copy-to-clipboard'
import { ethers } from 'ethers'
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAccount, useDisconnect } from 'wagmi'

import logo from 'assets/logo.png'
import { USER_ROLE_LABELS } from 'constants/user-role'
import { useAuthContext } from 'context/auth-provider'
import { logError } from 'utils/logger'

import 'component/common/style.scss'
import './style.scss'

declare global {
  interface Window {
    ethereum?: any
  }
}

const Header = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const navigate = useNavigate()
  const { userRole } = useAuthContext()
  const userRoleLabel = userRole ? USER_ROLE_LABELS[userRole] : null

  const handleOk = () => {
    googleLogout()
    sessionStorage.removeItem('token')
    sessionStorage.removeItem('userName')
    sessionStorage.removeItem('role')
    setIsModalOpen(false)
    navigate('/login')
  }

  // Hooks from Web3 Modal
  const { address } = useAccount()
  const { open } = useWeb3Modal()
  const { disconnect } = useDisconnect()
  const { selectedNetworkId } = useWeb3ModalState()

  // State to store wallet information
  const [walletInfo, setWalletInfo] = useState({
    address: '',
  })

  // Handle wallet connection
  const handleConnect = async () => {
    try {
      await open()
    } catch (error) {
      logError('Failed to connect wallet:', error)
    }
  }

  // Handle wallet disconnection
  const handleDisConnect = () => {
    disconnect()
    setWalletInfo({ address: '' })
  }

  // Update wallet info whenever address or network changes
  useEffect(() => {
    if (address) {
      setWalletInfo({
        address,
      })
    }
  }, [address, selectedNetworkId])

  const contentUser = (
    <div className="contentUser">
      <div className="contentUser-info">
        {userRoleLabel && <div className="contentUser-info__role">Role: {userRoleLabel}</div>}
      </div>
      <hr style={{ width: '100%' }} />
      <Button
        block
        onClick={() => {
          navigate('/update-password')
        }}
        type="text"
        className="contentUser-update-password"
      >
        <SettingOutlined /> Update password
      </Button>
      <hr style={{ width: '100%' }} />
      <Button
        type="text"
        className="logout-button"
        style={{ cursor: 'pointer' }}
        onClick={handleOk}
      >
        <LoginOutlined /> Log out
      </Button>
    </div>
  )

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  const [balance, setBalance] = useState<any>(null)

  useEffect(() => {
    const fetchBalance = async () => {
      if (address) {
        try {
          const provider = new ethers.providers.Web3Provider(window?.ethereum) // or use an RPC provider
          const balanceInWei = await provider.getBalance(address)
          const balanceInEth = ethers.utils.formatEther(balanceInWei)
          setBalance(balanceInEth)
        } catch (error) {
          logError('Error fetching balance:', error)
        }
      }
    }

    fetchBalance()
  }, [address])

  const rowUserInfo = () => {
    return (
      <>
        <div className="wrap-user-info">
          <div className="top-wrap">
            <div className="box-img">
              {/* <img src={dataInfo?.dataAccount?.avatar} alt="" /> */}
            </div>
            <div className="name-user">
              <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
                <img style={{ width: 60, height: 60 }} alt="" src="/images/logo-avt.png" />
                <div>
                  <div className="line-address">
                    Address:{' '}
                    <span style={{ color: 'white', marginLeft: 10 }}>
                      {address?.slice(0, 4)}...{walletInfo.address?.slice(-4)}
                    </span>
                    <Tooltip title="Copy">
                      <Button
                        type="link"
                        icon={<CopyOutlined />}
                        onClick={() => {
                          copy(walletInfo.address)
                          message.success('Copied Success!')
                        }}
                      />
                    </Tooltip>
                  </div>
                  <div className="line-address">
                    Balance:
                    <span style={{ color: 'white', marginLeft: 10 }}>
                      {parseFloat(balance).toFixed(6)} ETH{' '}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="menu-center">
            <ul className="list-user-menu">
              <a href={`https://basescan.org/address/${address}`} target="blank">
                <li>
                  <img src="/images/share-link.png" alt="" /> View on BaseScan
                </li>
              </a>
            </ul>
          </div>
          <div className="menu-bottom">
            <ul className="list-user-menu">
              <li onClick={handleDisConnect}>
                <img src="/images/logout.png" alt="" /> Disconnect
              </li>
            </ul>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <header
        className="header"
        style={{
          position: 'fixed',
          top: 0,
          zIndex: 10,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div className="main-header">
          <div className="left">
            <div className="box-img">
              <img src={logo} alt="Company Logo" />
            </div>
          </div>
          <div className="right" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            {walletInfo.address ? (
              <>
                <img src="/images/base.png" alt="" />
                <Dropdown overlay={rowUserInfo} placement="bottom">
                  <div className="item row">
                    <>
                      <img src="/images/wallet-s.png" alt="" />{' '}
                      <span className="text-wallet">
                        {address?.slice(0, 4)}...{address?.slice(-4)}
                      </span>
                    </>
                  </div>
                </Dropdown>
              </>
            ) : (
              <Button type="primary" onClick={handleConnect}>
                Connect Wallet
              </Button>
            )}
            <div className="user-login-box">
              <Dropdown overlay={contentUser} placement="bottom">
                <p className="right-user">
                  <img src="./images/logo-avt.png" alt="" />
                  {sessionStorage.getItem('userName')
                    ? `Hello, ${sessionStorage.getItem('userName')}`
                    : ''}
                </p>
              </Dropdown>
              {!sessionStorage.getItem('token') && (
                <Link to="/login">
                  <button className="login">Login</button>
                </Link>
              )}
            </div>
            <Modal
              title="Confirm"
              open={isModalOpen}
              onOk={handleOk}
              onCancel={handleCancel}
              centered
            >
              <p>Are you sure to logout?</p>
            </Modal>
          </div>
        </div>
      </header>
    </>
  )
}
export default Header
